import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentExportFailedAction = {
	type: 'DOCUMENT_EXPORT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentExportFailedAction => ({
	type: 'DOCUMENT_EXPORT_FAILED',
	payload,
});
